<template>
	<v-dialog
		v-model="open"
		max-width="1200"
		@click:outside="$emit('close')"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">添付ファイル一覧</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn color="white" icon class="ml-5 mr-10" @click="btnClick()">
					<v-icon>mdi-paperclip-plus</v-icon>
					ファイル追加
				</v-btn>
				<FileHistoryDialog :deleted_files="deleted_files" />
				<v-btn icon dark @click="$emit('close')" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-sheet elevation="0" class="mt-4">
					<v-select
						class="mr-10"
						v-model="tag_id"
						@change="fetchFiles($route.query.page ? $route.query.page : 1)"
						:items="type_tags"
						item-text="name"
						item-value="id"
						outlined
						dense
						hide-details
						background-color="white"
					/>
					<input style="display: none" ref="input" type="file" @change="selectedFile($event)" />

					<div
						class="table-container px-2 mt-4"
						@dragleave="dragLeave"
						@dragover.prevent="dragOver"
						@drop.prevent="dropFile"
					>
						<span>※ドラッグ＆ドロップでもファイルを添付できます。</span>
						<br />
						<span>※ファイルの保存先は現在一覧表示している場所になります。</span>
						<v-data-table
							class="mt-4"
							:class="{ enter: isEnter }"
							locale="ja-JP"
							:headers="headers"
							:items="attached_files"
							:mobile-breakpoint="240"
							hide-default-footer
							disable-filtering
							disable-pagination
							disable-sort
							no-data-text="データがありません。"
						>
							<template v-slot:item="{ item }">
								<tr :key="item.id">
									<td>
										<a :href="item.url" target="_blank">{{ item.name }}</a>
									</td>
									<td>
										<template v-if="authority_flag">
											<TemplateDeleteDialog ref="deleteDialog" onlyIcon>
												<template v-slot:button>
													<v-btn class="ma-1" dense dark color="red" @click="deleteFile(item.id)">
														削除する</v-btn
													>
												</template>
											</TemplateDeleteDialog>
										</template>
									</td>
								</tr>
							</template>
						</v-data-table>
					</div>
				</v-sheet>
			</v-sheet>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import FileHistoryDialog from "../matter/components/FileHistoryDialog.vue"

export default {
	components: {
		TemplateDeleteDialog,
		PaginationModule,
		FileHistoryDialog,
	},
	props: {
		id: {
			type: Number,
			required: true,
			default: "",
		},
	},
	data() {
		return {
			open: true,
			mainTitle: "案件",
			pageTitle: "添付ファイル一覧",
			type_tags: [],
			headers: [
				{ text: "ファイル名", value: "", width: "600px" },
				{ text: "", value: "", width: "50px" },
			],
			attached_files: [],
			tag_id: "null",
			isEnter: false,
			files: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			deleted_files: [],
			authority_flag: false,
			users: [],
			btn: "",
		}
	},

	mounted() {
		const page = 1
		this.fetchFiles(page)
	},

	methods: {
		fetchFiles(page) {
			authenticate.authenticateUser()
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/matters/${this.id}/attached_files`, {
					params: { tag_id: this.tag_id, page: page },
					headers,
				})
				.then((res) => {
					this.type_tags = res.data.type_tags

					const type_tag_ids = this.type_tags.map((type_tag) => type_tag.id)

					this.type_tags.unshift({ id: "null", name: "全てのファイル" })

					this.attached_files = res.data.attached_files
					this.pagination = res.data.pagination
					this.deleted_files = res.data.deleted_files
					this.authority_flag = res.data.authority_flag
					if (this.attached_files.length == 0) {
						const target = document.querySelector("td")
						target.style.height = "140px"
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchFiles(page)
		},
		dragLeave() {
			this.isEnter = false
		},
		dragOver() {
			this.isEnter = true
		},

		dropFile() {
			this.isEnter = false
			const headers = authenticate.setHeader()
			this.files = [...event.dataTransfer.files]
			this.files.forEach((file) => {
				const formData = new FormData()
				formData.append("file", file)
				let config = {
					headers: {
						"content-type": "multipart/form-data",
					},
				}
				axios
					.post(`/erp/v1/matters/${this.id}/attached_files`, formData, {
						params: { tag_id: this.tag_id, config: config },
						headers,
					})
					.then((res) => {
						this.$store.commit("setFlash", {
							text: "ファイルを追加しました",
							type: "notice",
						})
						this.fetchFiles(this.$route.query.page ? this.$route.query.page : 1)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			})
		},

		deleteFile(id) {
			const headers = authenticate.setHeader()
			axios
				.delete(`/erp/v1/matters/${this.id}/attached_files/${id}`, {
					params: { tag_id: this.tag_id },
					headers,
				})
				.then((res) => {
					this.pattern = res.data.pattern
					this.$store.commit("setFlash", {
						text: "ファイルを削除しました",
						type: "notice",
					})
					this.$refs.deleteDialog.closeDialog()
					this.fetchFiles(this.$route.query.page ? this.$route.query.page : 1)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		btnClick() {
			this.$refs.input.click()
		},
		async selectedFile(event) {
			const headers = authenticate.setHeader()
			this.files = [...event.target.files]
			this.files.forEach((file) => {
				const formData = new FormData()
				formData.append("file", file)
				let config = {
					headers: {
						"content-type": "multipart/form-data",
					},
				}
				axios
					.post(`/erp/v1/matters/${this.id}/attached_files`, formData, {
						params: { tag_id: this.tag_id, config: config },
						headers,
					})
					.then((res) => {
						this.$store.commit("setFlash", {
							text: "ファイルを追加しました",
							type: "notice",
						})
						this.fetchFiles(this.$route.query.page ? this.$route.query.page : 1)
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			})
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../stylesheet/variable.scss";
.enter {
	border: 5px solid $sub-color;
}
</style>
